var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilityBillsProcessed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.61 30.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #04abc1;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_805"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    className: "cls-1",
    d: "M22.13,3.75h-5.07c-.33,0-.64.18-.8.47l-7.57,13.25c-.25.44-.1,1.01.35,1.26.14.08.29.12.45.12h5.6l-2.72,6.61c-.2.47.03,1.01.5,1.21.38.16.81.05,1.07-.27l8.54-10.34c.33-.39.27-.98-.12-1.3-.17-.14-.38-.21-.59-.21h-4.2l5.38-9.42c.25-.44.1-1.01-.35-1.26-.14-.08-.3-.12-.46-.12h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilityBillsProcessed);
export default __webpack_public_path__ + "static/media/Utility Bills Processed.827590ebdd4e83bd7350ca04aba1fda2.svg";
export { ForwardRef as ReactComponent };